import { render, staticRenderFns } from "./ContestRoute.vue?vue&type=template&id=08c3e8a6&scoped=true&"
import script from "./ContestRoute.vue?vue&type=script&lang=js&"
export * from "./ContestRoute.vue?vue&type=script&lang=js&"
import style0 from "./ContestRoute.vue?vue&type=style&index=0&id=08c3e8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3e8a6",
  null
  
)

export default component.exports